import { AppJsonDecoder } from 'src/app/utils/app-json-decoder';
import { User } from '../user/user.model';

export class Agreement {
  id?: string;
  user?: User;
  type?: string;
  school_year?: string;
  hours?: number;
  ral?: number;
  monthly_gross?: number;
  monthly_net?: number;
  code?: string;
  description?: string;
  attachment?: string;
  start?: Date;
  end?: Date;
  createdAt?: Date;
  updatedAt?: Date;

  constructor(json?: any) {
    if (!json) return;
    this.id = json._id || json.id;
    this.user = new User(json.user);
    this.type = json.type;
    this.school_year = json.school_year;
    this.hours = json.hours;
    this.ral = AppJsonDecoder.optPriceValue(json.ral);
    this.monthly_gross = AppJsonDecoder.optPriceValue(json.monthly_gross);
    this.monthly_net = AppJsonDecoder.optPriceValue(json.monthly_net);
    this.code = json.code;
    this.description = json.description;
    this.start = AppJsonDecoder.optDate(json.start);
    this.end = AppJsonDecoder.optDate(json.end);
    this.attachment = json.attachment;
    this.createdAt = AppJsonDecoder.optDate(json.createdAt);
    this.updatedAt = AppJsonDecoder.optDate(json.updatedAt);
  }
}
